var _path, _path2, _rect, _mask, _g, _rect2, _mask2, _g2, _rect3, _mask3, _g3, _rect4, _mask4, _g4, _mask5, _g5, _rect5, _path3, _rect6, _rect7, _rect8, _line, _rect9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgColorplate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 310,
    height: 176,
    viewBox: "0 0 310 176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5C0 2.23857 2.23858 0 5 0H305C307.761 0 310 2.23858 310 5V176H0V5Z",
    fill: "#F5F5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 5C0 2.23857 2.23858 0 5 0H56V176H0V5Z",
    fill: "#884EA2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 214,
    y: 7,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "#B8E986"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 214,
    y: 7,
    width: 23,
    height: 23
  }, /*#__PURE__*/React.createElement("rect", {
    x: 214,
    y: 7,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 212.562,
    y: 5.5625,
    width: 25.875,
    height: 25.875,
    rx: 12.9375,
    fill: "#DF126C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.25 22.5622V23.0989C231.25 23.7314 230.733 24.2489 230.1 24.2489H220.9C220.268 24.2489 219.75 23.7314 219.75 23.0989V22.5622C219.75 21.1631 221.379 20.3197 222.913 19.6489C222.97 19.6297 223.008 19.6106 223.066 19.5722C223.181 19.5147 223.315 19.5147 223.43 19.5914C224.043 19.9939 224.753 20.2239 225.5 20.2239C226.247 20.2239 226.957 19.9939 227.57 19.6106C227.685 19.5339 227.819 19.5339 227.934 19.5914C227.992 19.6106 228.03 19.6297 228.088 19.6681C229.621 20.3197 231.25 21.1631 231.25 22.5622Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.5 12.75C227.077 12.75 228.356 14.1658 228.356 15.9125C228.356 17.6592 227.077 19.075 225.5 19.075C223.923 19.075 222.644 17.6592 222.644 15.9125C222.644 14.1658 223.923 12.75 225.5 12.75Z",
    fill: "white"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 25,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "#B8E986"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 25,
    width: 23,
    height: 23
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 25,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.5625,
    y: 23.5625,
    width: 25.875,
    height: 25.875,
    rx: 12.9375,
    fill: "white"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 76,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "#B8E986"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "mask2",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 76,
    width: 23,
    height: 23
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 76,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.5625,
    y: 74.5625,
    width: 25.875,
    height: 25.875,
    rx: 12.9375,
    fill: "white"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 133,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "#B8E986"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "mask3",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 133,
    width: 23,
    height: 23
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 133,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.5625,
    y: 131.562,
    width: 25.875,
    height: 25.875,
    rx: 12.9375,
    fill: "white"
  }))), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "mask4",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 310,
    height: 176
  }, /*#__PURE__*/React.createElement("rect", {
    width: 310,
    height: 176,
    fill: "#F5F5F5"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 48,
    width: 249,
    height: 140,
    rx: 4,
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 5C0 2.23857 2.23858 0 5 0H305C307.761 0 310 2.23858 310 5V176H0V5Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 5C0 2.23857 2.23858 0 5 0H56V176H0V5Z",
    fill: "#884EA2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214,
    y: 7,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "#B8E986"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask5",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 214,
    y: 7,
    width: 23,
    height: 23
  }, /*#__PURE__*/React.createElement("rect", {
    x: 214,
    y: 7,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 212.562,
    y: 5.5625,
    width: 25.875,
    height: 25.875,
    rx: 12.9375,
    fill: "#DF126C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.25 22.5622V23.0989C231.25 23.7314 230.733 24.2489 230.1 24.2489H220.9C220.268 24.2489 219.75 23.7314 219.75 23.0989V22.5622C219.75 21.1631 221.379 20.3197 222.913 19.6489C222.97 19.6297 223.008 19.6106 223.066 19.5722C223.181 19.5147 223.315 19.5147 223.43 19.5914C224.043 19.9939 224.753 20.2239 225.5 20.2239C226.247 20.2239 226.957 19.9939 227.57 19.6106C227.685 19.5339 227.819 19.5339 227.934 19.5914C227.992 19.6106 228.03 19.6297 228.088 19.6681C229.621 20.3197 231.25 21.1631 231.25 22.5622Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.5 12.75C227.077 12.75 228.356 14.1658 228.356 15.9125C228.356 17.6592 227.077 19.075 225.5 19.075C223.923 19.075 222.644 17.6592 222.644 15.9125C222.644 14.1658 223.923 12.75 225.5 12.75Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 25,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "#B8E986"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask6",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 25,
    width: 23,
    height: 23
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 25,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.5625,
    y: 23.5625,
    width: 25.875,
    height: 25.875,
    rx: 12.9375,
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 76,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "#B8E986"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask7",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 76,
    width: 23,
    height: 23
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 76,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.5625,
    y: 74.5625,
    width: 25.875,
    height: 25.875,
    rx: 12.9375,
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 133,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "#B8E986"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask8",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 133,
    width: 23,
    height: 23
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 133,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.5625,
    y: 131.562,
    width: 25.875,
    height: 25.875,
    rx: 12.9375,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 310,
    height: 176
  }, /*#__PURE__*/React.createElement("rect", {
    width: 310,
    height: 176,
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 48,
    width: 249,
    height: 140,
    rx: 4,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 71,
    width: 126,
    height: 17,
    rx: 8.5,
    fill: "#263154"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 93,
    width: 74,
    height: 12,
    rx: 6,
    fill: "#6B6F7A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243,
    y: 15,
    width: 49,
    height: 8,
    rx: 4,
    fill: "#263154"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 110,
    y1: 123.5,
    x2: 310,
    y2: 123.5,
    stroke: "#E2E2E2"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 111,
    y: 133,
    width: 95,
    height: 29,
    rx: 2,
    fill: "#60034C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M137.323 150.928C137.398 150.928 137.463 150.958 137.519 151.019L138.058 151.6C137.647 152.076 137.148 152.447 136.56 152.713C135.977 152.979 135.27 153.112 134.439 153.112C133.72 153.112 133.067 152.988 132.479 152.741C131.891 152.489 131.389 152.139 130.974 151.691C130.559 151.238 130.237 150.697 130.008 150.067C129.779 149.437 129.665 148.744 129.665 147.988C129.665 147.232 129.784 146.539 130.022 145.909C130.26 145.279 130.594 144.738 131.023 144.285C131.457 143.832 131.975 143.482 132.577 143.235C133.179 142.983 133.844 142.857 134.572 142.857C135.286 142.857 135.916 142.971 136.462 143.2C137.008 143.429 137.489 143.739 137.904 144.131L137.456 144.754C137.428 144.801 137.391 144.84 137.344 144.873C137.302 144.901 137.244 144.915 137.169 144.915C137.085 144.915 136.982 144.871 136.861 144.782C136.74 144.689 136.581 144.586 136.385 144.474C136.189 144.362 135.944 144.262 135.65 144.173C135.356 144.08 134.994 144.033 134.565 144.033C134.047 144.033 133.573 144.124 133.144 144.306C132.715 144.483 132.344 144.742 132.031 145.083C131.723 145.424 131.483 145.839 131.31 146.329C131.137 146.819 131.051 147.372 131.051 147.988C131.051 148.613 131.14 149.171 131.317 149.661C131.499 150.151 131.744 150.566 132.052 150.907C132.365 151.243 132.731 151.5 133.151 151.677C133.576 151.854 134.033 151.943 134.523 151.943C134.822 151.943 135.09 151.927 135.328 151.894C135.571 151.857 135.792 151.801 135.993 151.726C136.198 151.651 136.387 151.558 136.56 151.446C136.737 151.329 136.912 151.192 137.085 151.033C137.164 150.963 137.244 150.928 137.323 150.928ZM140.627 142.689V153H139.381V142.689H140.627ZM143.963 145.909V153H142.717V145.909H143.963ZM144.229 143.683C144.229 143.804 144.203 143.919 144.152 144.026C144.105 144.129 144.04 144.222 143.956 144.306C143.877 144.385 143.781 144.448 143.669 144.495C143.562 144.542 143.447 144.565 143.326 144.565C143.205 144.565 143.09 144.542 142.983 144.495C142.88 144.448 142.789 144.385 142.71 144.306C142.631 144.222 142.568 144.129 142.521 144.026C142.474 143.919 142.451 143.804 142.451 143.683C142.451 143.562 142.474 143.447 142.521 143.34C142.568 143.228 142.631 143.132 142.71 143.053C142.789 142.969 142.88 142.904 142.983 142.857C143.09 142.81 143.205 142.787 143.326 142.787C143.447 142.787 143.562 142.81 143.669 142.857C143.781 142.904 143.877 142.969 143.956 143.053C144.04 143.132 144.105 143.228 144.152 143.34C144.203 143.447 144.229 143.562 144.229 143.683ZM150.945 147.169C150.908 147.22 150.871 147.26 150.833 147.288C150.796 147.316 150.745 147.33 150.679 147.33C150.609 147.33 150.532 147.302 150.448 147.246C150.364 147.185 150.259 147.12 150.133 147.05C150.012 146.98 149.86 146.917 149.678 146.861C149.501 146.8 149.282 146.77 149.02 146.77C148.67 146.77 148.362 146.833 148.096 146.959C147.83 147.08 147.606 147.258 147.424 147.491C147.247 147.724 147.112 148.007 147.018 148.338C146.93 148.669 146.885 149.04 146.885 149.451C146.885 149.88 146.934 150.263 147.032 150.599C147.13 150.93 147.268 151.21 147.445 151.439C147.627 151.663 147.844 151.836 148.096 151.957C148.353 152.074 148.64 152.132 148.957 152.132C149.261 152.132 149.51 152.097 149.706 152.027C149.902 151.952 150.063 151.871 150.189 151.782C150.32 151.693 150.427 151.614 150.511 151.544C150.6 151.469 150.686 151.432 150.77 151.432C150.873 151.432 150.952 151.472 151.008 151.551L151.358 152.006C151.204 152.197 151.029 152.361 150.833 152.496C150.637 152.631 150.425 152.746 150.196 152.839C149.972 152.928 149.737 152.993 149.489 153.035C149.242 153.077 148.99 153.098 148.733 153.098C148.29 153.098 147.877 153.016 147.494 152.853C147.116 152.69 146.787 152.454 146.507 152.146C146.227 151.833 146.008 151.451 145.849 150.998C145.691 150.545 145.611 150.03 145.611 149.451C145.611 148.924 145.684 148.436 145.828 147.988C145.978 147.54 146.192 147.155 146.472 146.833C146.757 146.506 147.105 146.252 147.515 146.07C147.931 145.888 148.407 145.797 148.943 145.797C149.443 145.797 149.881 145.879 150.259 146.042C150.642 146.201 150.98 146.427 151.274 146.721L150.945 147.169ZM153.949 142.689V148.758H154.271C154.364 148.758 154.441 148.746 154.502 148.723C154.567 148.695 154.635 148.641 154.705 148.562L156.945 146.161C157.01 146.082 157.078 146.021 157.148 145.979C157.223 145.932 157.321 145.909 157.442 145.909H158.569L155.958 148.688C155.832 148.847 155.697 148.97 155.552 149.059C155.636 149.115 155.711 149.18 155.776 149.255C155.846 149.325 155.911 149.407 155.972 149.5L158.744 153H157.631C157.524 153 157.43 152.984 157.351 152.951C157.276 152.914 157.211 152.848 157.155 152.755L154.824 149.85C154.754 149.752 154.684 149.689 154.614 149.661C154.549 149.628 154.446 149.612 154.306 149.612H153.949V153H152.696V142.689H153.949ZM174.118 142.969V153H172.928V145.629C172.928 145.531 172.931 145.426 172.935 145.314C172.945 145.202 172.954 145.088 172.963 144.971L169.519 151.243C169.412 151.453 169.249 151.558 169.029 151.558H168.833C168.614 151.558 168.451 151.453 168.343 151.243L164.829 144.943C164.857 145.19 164.871 145.419 164.871 145.629V153H163.681V142.969H164.682C164.804 142.969 164.897 142.981 164.962 143.004C165.028 143.027 165.091 143.093 165.151 143.2L168.616 149.374C168.672 149.486 168.726 149.603 168.777 149.724C168.833 149.845 168.885 149.969 168.931 150.095C168.978 149.969 169.027 149.845 169.078 149.724C169.13 149.598 169.186 149.479 169.246 149.367L172.648 143.2C172.704 143.093 172.765 143.027 172.83 143.004C172.9 142.981 172.996 142.969 173.117 142.969H174.118ZM180.917 148.681C180.917 148.392 180.875 148.128 180.791 147.89C180.711 147.647 180.592 147.44 180.434 147.267C180.28 147.09 180.091 146.954 179.867 146.861C179.643 146.763 179.388 146.714 179.104 146.714C178.506 146.714 178.033 146.889 177.683 147.239C177.337 147.584 177.123 148.065 177.039 148.681H180.917ZM181.925 152.006C181.771 152.193 181.586 152.356 181.372 152.496C181.157 152.631 180.926 152.743 180.679 152.832C180.436 152.921 180.184 152.986 179.923 153.028C179.661 153.075 179.402 153.098 179.146 153.098C178.656 153.098 178.203 153.016 177.788 152.853C177.377 152.685 177.02 152.442 176.717 152.125C176.418 151.803 176.185 151.406 176.017 150.935C175.849 150.464 175.765 149.922 175.765 149.311C175.765 148.816 175.839 148.354 175.989 147.925C176.143 147.496 176.362 147.125 176.647 146.812C176.931 146.495 177.279 146.247 177.69 146.07C178.1 145.888 178.562 145.797 179.076 145.797C179.5 145.797 179.892 145.869 180.252 146.014C180.616 146.154 180.928 146.359 181.19 146.63C181.456 146.896 181.663 147.227 181.813 147.624C181.962 148.016 182.037 148.464 182.037 148.968C182.037 149.164 182.016 149.295 181.974 149.36C181.932 149.425 181.852 149.458 181.736 149.458H176.997C177.011 149.906 177.071 150.296 177.179 150.627C177.291 150.958 177.445 151.236 177.641 151.46C177.837 151.679 178.07 151.845 178.341 151.957C178.611 152.064 178.915 152.118 179.251 152.118C179.563 152.118 179.832 152.083 180.056 152.013C180.284 151.938 180.48 151.859 180.644 151.775C180.807 151.691 180.942 151.614 181.05 151.544C181.162 151.469 181.257 151.432 181.337 151.432C181.439 151.432 181.519 151.472 181.575 151.551L181.925 152.006ZM185.065 142.969V146.973C185.065 147.183 185.06 147.388 185.051 147.589C185.042 147.79 185.03 147.993 185.016 148.198C185.002 148.399 184.983 148.606 184.96 148.821C184.941 149.031 184.918 149.257 184.89 149.5H184.05C184.022 149.257 183.996 149.031 183.973 148.821C183.954 148.606 183.938 148.399 183.924 148.198C183.91 147.993 183.898 147.79 183.889 147.589C183.88 147.388 183.875 147.183 183.875 146.973V142.969H185.065ZM183.574 152.23C183.574 152.109 183.595 151.994 183.637 151.887C183.684 151.78 183.747 151.686 183.826 151.607C183.905 151.528 183.996 151.465 184.099 151.418C184.206 151.371 184.323 151.348 184.449 151.348C184.57 151.348 184.682 151.371 184.785 151.418C184.892 151.465 184.986 151.528 185.065 151.607C185.144 151.686 185.207 151.78 185.254 151.887C185.301 151.994 185.324 152.109 185.324 152.23C185.324 152.356 185.301 152.473 185.254 152.58C185.207 152.683 185.144 152.774 185.065 152.853C184.986 152.932 184.892 152.993 184.785 153.035C184.682 153.082 184.57 153.105 184.449 153.105C184.323 153.105 184.206 153.082 184.099 153.035C183.996 152.993 183.905 152.932 183.826 152.853C183.747 152.774 183.684 152.683 183.637 152.58C183.595 152.473 183.574 152.356 183.574 152.23Z",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 71,
    width: 126,
    height: 17,
    rx: 8.5,
    fill: "#263154"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 93,
    width: 74,
    height: 12,
    rx: 6,
    fill: "#6B6F7A"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 243,
    y: 15,
    width: 49,
    height: 8,
    rx: 4,
    fill: "#263154"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 110,
    y1: 123.5,
    x2: 310,
    y2: 123.5,
    stroke: "#E2E2E2"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 292,
    y: 118,
    width: 12,
    height: 12,
    rx: 6,
    fill: "#0A7593"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 79,
    y: 43,
    width: 259,
    height: 150,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 79,
    y: 43,
    width: 259,
    height: 150,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorplate);
export default __webpack_public_path__ + "static/media/colorplate.766ca9deafac30270f0eed9f35e5df42.svg";
export { ForwardRef as ReactComponent };